module.exports = __webpack_public_path__ + "img/content-01.1f473763.jpg";